import React, { Component } from "react";

// import Checkbox from "@mui/material/Checkbox";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import Status from "../../Status/Status";

class TableRow extends Component {
  render() {
    let { item, skipFirstColumn = false } = this.props;
    return (
      <tr>
        {/* <td>
          <Checkbox
            checked={false}
            value="checkedA"
            inputProps={{
              "aria-label": "primary checkbox"
            }}
          />
        </td> */}
        {item.map((rowData, index) => {
          if (skipFirstColumn && index === 0) {
            return false;
          } else if (index === item.length - 2) {
            let splitWord = rowData.split("-");
            if (splitWord[1] === "true") {
              return (
                <td
                  key={index}
                  onClick={() => this.props.click(item[item.length - 1])}
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                  }}
                >
                  <Status status={splitWord[0]} text={splitWord[0]} size="xs" />
                  <Status status="success" text="FOC" size="xs" />
                </td>
              );
            } else {
              return (
                <td
                  key={index}
                  onClick={() => this.props.click(item[item.length - 1])}
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                  }}
                >
                  <Status status={splitWord[0]} text={splitWord[0]} />
                </td>
              );
            }
          } else if (index === item.length - 1) {
            return false;
          }
          return (
            <td key={index} onClick={() => this.props.click(item[item.length - 1])}>
              {rowData}
            </td>
          );
        })}
        {/* <td>
          <Status status="completed" text="Completed" />
        </td> */}
        {this.props.icon ? (
          <td onClick={() => this.props.delete(item[item.length - 1])}>
            <DeleteOutlineIcon />
          </td>
        ) : (
          <td onClick={() => this.props.delete(item[0])}>
            <span className="tableSpan">Report a problem</span>
          </td>
        )}
      </tr>
    );
  }
}

export default TableRow;
